import { Component, OnInit } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { TopicService } from '../topic.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-t-all-exercises',
  templateUrl: './t-all-exercises.component.html',
  styleUrls: ['../../General/tiles.css', './t-all-exercises.component.css']
})
export class TAllExercisesComponent extends GeneralComponent {

  allExercises: any[] = [];
  examId: number = undefined;
  title = '';

  movingExercises: any[] = [];

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute, private messageService: MessageService) {
    super(topicService);
    this.allExercises = topicService.getAllExercises().map(exercise => ({...exercise}));
  }

  /** saves the changes made in order */
  saveChanges() {
    let index = 1;
    for (const exercise of this.allExercises) {
      exercise.id = index;
      index++;
    }
    this.topicService.updateAllExercises(this.allExercises);

    this.messageService.addAlertWithTimeout(this.get('saveDone'), 'success', 5000);
  }

  /** deletes the exercise from the exercise list. Does NOT save
   * @param {number} index - index of exercise to delete
  */
 deleteExercise(index: number): void {
   this.allExercises.splice(index, 1);
 }

 get_title() {
  return this.title;
}

/**
 * assign exercise to general exercises
 * @param event - contains the exericse to move
 */
dragToExercises(event: any) {
  const index = this.allExercises.map((v, i) => [i, v.id]).filter(v => v[1] === event.dragData).map(v => +v[0])[0];
  const exercise = this.allExercises[index];
  const maxId = this.topicService.getMaxId();
  exercise.id = maxId + 1;
  this.movingExercises.push({
    exercise: exercise
  });
  this.allExercises.splice(index, 1);
}

}
